























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'

@Component
export default class PipelinesEnabledCrumb extends Vue {
    @Prop() readonly route!: Route
    @Prop() readonly last!: boolean

    get componentClasses(): object {
        return {
            'crumb': true,
            'crumb--last': this.last,
        }
    }
}

